import FilterOperator from "@mapmycustomers/shared/enum/FilterOperator";
import { SimpleCondition } from "@mapmycustomers/shared/types/viewModel/internalModel/FilterModel";

import { DealFieldName } from "@app/util/fieldModel/DealFieldModel";

import ForecastViewMode from "../enum/ForecastViewMode";

import { endOf, startOf } from "./forecastPeriodBounds";

const getClosingDateRangeCondition = (viewMode: ForecastViewMode, date: Date): SimpleCondition => ({
  fieldFilterName: DealFieldName.CLOSING_DATE,
  operator: FilterOperator.IN_RANGE,
  value: [startOf[viewMode](date).toISOString(), endOf[viewMode](date).toISOString()],
});

export default getClosingDateRangeCondition;
